document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.section--collapsible-tabs[id]');

    if (!sections.length) return;

    function setActiveFromHash() {
        const hash = window.location.hash.replace('#', '');

        sections.forEach((section) => section.classList.remove('is-active'));

        if (!hash) return;

        const target = document.getElementById(hash);

        if (target) {
            target.classList.add('is-active');
        }
    }

    window.addEventListener('hashchange', setActiveFromHash);
    setActiveFromHash();
});

